import React from "react";
import {Controller, ControllerProps, useController} from "react-hook-form";

import {IRadioProps, Radio} from "@pg-design/radio-module";

/*
    Removing type scenarios here because of timing issues because of TS issues
    TODO: We should probably move from TS scenarios (or other "props guards") to simple js console warnings (visible only in dev mode)
 */
type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> &
    Omit<IRadioProps, "onChange" | "labelContent"> & {
        labelContent: string | React.JSX.Element;
        "aria-labelledby"?: never;
        readOnly?: never;
    };

export function RadioControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "CheckboxControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    const fieldValue = props.value;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => (
                <Radio
                    {...field}
                    {...inputProps}
                    isActive={field.value === fieldValue}
                    onChange={(_name, _isActive, value) => {
                        field.onChange(value);
                    }}
                />
            )}
        />
    );
}
import React from "react";
import {Controller, ControllerProps, useController} from "react-hook-form";

import {IRadioProps, Radio} from "@pg-design/radio-module";

/*
    Removing type scenarios here because of timing issues because of TS issues
    TODO: We should probably move from TS scenarios (or other "props guards") to simple js console warnings (visible only in dev mode)
 */
type IProps<FormValues extends object> = Omit<ControllerProps<FormValues>, "render" | "value"> &
    Omit<IRadioProps, "onChange" | "labelContent"> & {
        labelContent: string | React.JSX.Element;
        "aria-labelledby"?: never;
        readOnly?: never;
    };

export function RadioControlled<FormValues extends object>(props: IProps<FormValues>) {
    const {name, defaultValue, control, ...inputProps} = props;
    const fieldController = useController<FormValues>({control, name});

    if (!fieldController) {
        throw new Error(
            "CheckboxControlled is not wrapped in FormProvider, in this case, please wrap it with FormProvider or provide an optional 'control' prop"
        );
    }

    const fieldValue = props.value;

    return (
        <Controller
            name={name}
            control={control}
            defaultValue={defaultValue}
            render={({field}) => (
                <Radio
                    {...field}
                    {...inputProps}
                    isActive={field.value === fieldValue}
                    onChange={(_name, _isActive, value) => {
                        field.onChange(value);
                    }}
                />
            )}
        />
    );
}
